export const AUTHORS = [{ name: "Krzysiu" }, { name: "Tomek" }] as const

export default AUTHORS
